module.exports = __webpack_public_path__ + "static/media/lobster.f41ab092.jpg";